import React from 'react';
import CommonModal from './CommonModal';

const StoreSelectionModal = ({
  isOpen,
  stores,
  selectedStores,
  onToggle,
  onSave,
  onClose
}) => {

  return (
    <CommonModal isOpen={isOpen} onClose={onClose} elId="uberStoresModal">

      <div className="modal-header">
        <h5 className="modal-title">Select Store</h5>

        <button
          type="button"
          className="btn-close"
          onClick={onClose}
        />
      </div>

      <div className="modal-body">

        {stores?.map(store => (
          <div key={store.id} className="form-check py-2">

            <input
              className="form-check-input"
              type="checkbox"
              checked={selectedStores.includes(store.id)}
              onChange={() => onToggle(store.id)}
              id={`store-${store.id}`}
            />

            <label className="form-check-label" htmlFor={`store-${store.id}`}>
              {store.name} - {store.id}
              <br />
              ({store?.location?.street_address_line_one})
            </label>

          </div>
        ))}

      </div>

      <div className="modal-footer">
        <button className="btn btn-primary" onClick={onSave}>
          Save
        </button>
      </div>

    </CommonModal>
  );
};

export default StoreSelectionModal;